const src = import.meta.ROLLUP_FILE_URL_LphhLScmzwPqWwTyAbd7ig;
export default {
  src,
  srcSet: src + " " + 1590 + "w",
  width: 1590,
  height: 884,
};